import { HttpBackend } from '@angular/common/http';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

/**
 * Use this function to provide the component-specific language location
 * @param subfolderName - The name of the subfolder inside ./public/l18n/ where the component-specific translations are located. If not provided, it will use the common location.
 * @example
 * ```typescript
 * \@Component({
 *    standalone:true,
 *    providers:[
 *      ...provideComponentLanguages(['./i18n/common/', './i18n/vehicle/']),
 *    ]
 * })
 * ```
 */
export function provideComponentLanguages(directoryNames?: string[]) {
  function HttpLoaderFactory(http: HttpBackend): MultiTranslateHttpLoader {
    return new MultiTranslateHttpLoader(http, directoryNames);
  }

  return [
    {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory, // Custom loader for this component
      deps: [HttpBackend],
    },
    TranslateService,
  ];
}
